var _excluded = ["show", "prefixCls", "className", "enableSize", "icon", "style", "width", "divider", "header", "footer", "children", "containerRef", "inModal"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useCombineRef, useElementSize, useForceUpdate } from '@okee-uikit/react-hooks';
import { classnames } from '@okee-uikit/react-utils';
import { usePrefixCls } from '@okee-uikit/react-config';
export var Content = function Content(props) {
  var show = props.show,
      prefixCls = props.prefixCls,
      className = props.className,
      _props$enableSize = props.enableSize,
      enableSize = _props$enableSize === void 0 ? false : _props$enableSize,
      icon = props.icon,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      width = props.width,
      divider = props.divider,
      header = props.header,
      footer = props.footer,
      children = props.children,
      _props$containerRef = props.containerRef,
      outerRef = _props$containerRef === void 0 ? null : _props$containerRef,
      inModal = props.inModal,
      extra = _objectWithoutProperties(props, _excluded);

  var containerRef = useRef(null);
  var headerRef = useRef(null);
  var footerRef = useRef(null);
  var bodyRef = useRef(null);
  var update = useForceUpdate();
  var ref = useCombineRef(containerRef, outerRef);
  var containerSize = useElementSize(containerRef, function () {
    return enableSize;
  }, update);
  var headerSize = useElementSize(headerRef, function () {
    return enableSize;
  }, update);
  var footerSize = useElementSize(footerRef, function () {
    return enableSize;
  }, update);
  var bodySize = useElementSize(bodyRef, function () {
    return enableSize;
  }, update);
  var innerHeight = containerSize.height - headerSize.height - footerSize.height;
  var isInnerHeightScroll = enableSize && innerHeight < bodySize.height;
  var cls = classnames(usePrefixCls('content-container'), usePrefixCls("".concat(prefixCls, "-container")), className);
  var height = style.height,
      maxHeight = style.maxHeight;
  var withNumberHeight = height == null ? false : typeof height === 'number' ? true : !!height.match(/\d/g);
  var withNumberMaxHeight = maxHeight == null ? false : typeof maxHeight === 'number' ? true : !!maxHeight.match(/\d/g);
  var innerCls = classnames(usePrefixCls('content-inner', {
    notModal: !inModal || withNumberHeight || withNumberMaxHeight
  }), usePrefixCls("".concat(prefixCls, "-inner"), {
    'no-footer': !footer,
    overflow: isInnerHeightScroll
  }));
  var iconWrapperCls = classnames(usePrefixCls('content-icon-wrapper'), usePrefixCls("".concat(prefixCls, "-icon-wrapper")));
  var innerWrapperCls = classnames(usePrefixCls('content-inner-wrapper'), usePrefixCls("".concat(prefixCls, "-inner-wrapper")));
  var headerCls = classnames(usePrefixCls('content-header'), usePrefixCls("".concat(prefixCls, "-header"), {
    overflow: isInnerHeightScroll,
    divider: divider
  }));
  var footerCls = classnames(usePrefixCls('content-footer'), usePrefixCls("".concat(prefixCls, "-footer"), {
    overflow: isInnerHeightScroll,
    divider: divider
  }));
  var renderIconWrapper = useCallback(function (iconJsx) {
    if (!icon) {
      return null;
    }

    return React.createElement("div", {
      className: iconWrapperCls
    }, iconJsx);
  }, [icon]);

  var renderHeader = function renderHeader() {
    if (!header) {
      return null;
    }

    return React.createElement("div", {
      ref: headerRef,
      className: headerCls
    }, renderIconWrapper(icon), React.createElement("div", {
      className: innerWrapperCls
    }, typeof header === 'function' ? header() : header));
  };

  var renderFooter = function renderFooter() {
    if (!footer) {
      return null;
    }

    return React.createElement("div", {
      ref: footerRef,
      className: footerCls
    }, renderIconWrapper(), React.createElement("div", {
      className: innerWrapperCls
    }, typeof footer === 'function' ? footer() : footer));
  };

  var tabIndexRef = useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      ActiveElement = _useState2[0],
      setActiveElement = _useState2[1];

  useEffect(function () {
    var _a, _b;

    if (show === undefined) {
      return;
    }

    if (show) {
      setActiveElement(document.activeElement);
      (_a = tabIndexRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    } else {
      (_b = tabIndexRef.current) === null || _b === void 0 ? void 0 : _b.blur();
      ActiveElement && ActiveElement.focus && typeof ActiveElement.focus === 'function' && ActiveElement.focus();
    }

    return function () {
      var _a;

      if (document.activeElement === tabIndexRef.current) {
        (_a = tabIndexRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      }
    };
  }, [show]);
  return React.createElement("div", _objectSpread(_objectSpread({}, extra), {}, {
    ref: ref,
    className: cls,
    style: _objectSpread(_objectSpread({}, style), {}, {
      width: width != null ? width : style.width
    })
  }), React.createElement("div", {
    ref: tabIndexRef,
    tabIndex: -1
  }), renderHeader(), React.createElement("div", {
    className: innerCls,
    style: {
      height: enableSize ? "".concat(innerHeight, "px") : undefined
    }
  }, renderIconWrapper(!header && icon), React.createElement("div", {
    className: innerWrapperCls,
    ref: bodyRef
  }, typeof children === 'function' ? children() : children)), renderFooter());
};